import { render, staticRenderFns } from "./AuthenticatedView.vue?vue&type=template&id=3ba43f06"
import script from "./AuthenticatedView.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports